import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../types/UserConfig";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    if (userConfigProvider.config.riskManager != null) {
        $stateProvider.state("risk", {
            url: "/risk",
            templateUrl: "app/risk/risk.tpl.html",
            controller: "riskCtrl as risk",
            data: {
                pageTitle: "Risk Manager"
            }
        });
    }
}
